/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import { Button } from '@radix-ui/themes';

import { styled, useCallback } from 'fierry/react';

import Countdown from 'solis/claude/element/countdown';
import Swatch from 'solis/claude/element/user/swatch';


const getDate = ({ event }) =>
{
  return event.date;
};


const getBoard = ({ event }) =>
{
  return event.getZone().getBoard();
};


const getUser = ({ event }) =>
{
  return event.user;
};


const getLabel = ({ event }) =>
{
  return event.getLabel();
};


const isOriginalEvent = ({ event, originalTimeline }) =>
{
  return originalTimeline.hasEvent(event);
};


const isSelected = ({ event, currentDate }) =>
{
  return event.date === currentDate;
};


const Container = styled(Button)`
  justify-content: flex-start;
  gap: var(--space-2);
`;


const When = styled.span`
  flex-shrink: 0;

  width: 40px;
  text-align: right;
  font-variant-numeric: tabular-nums;
`;


const OnClick = (event, index, onSelect) =>
{
  onSelect(index);
};


const Component = (props) =>
(
  <Container variant = 'ghost' color = 'gray' size = '1' highContrast = {isSelected(props)} onClick = {props.onClick}>

    <When>
      <Countdown date = {getDate(props)} compact />
    </When>

    <Swatch board = {getBoard(props)} user = {getUser(props)} hollow = {!isOriginalEvent(props)} />

    {getLabel(props)}

  </Container>
);


export default (props) =>
{
  const onClick = useCallback(OnClick, [ props.index, props.onSelect ]);

  return <Component {...props} onClick = {onClick} />;
};
